export const initialPoint = {
  lat: 0,
  lng: 0,
};
